import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";

import useStateRef from 'react-usestateref';
import swal from 'sweetalert';
import toast, { Toaster } from 'react-hot-toast';
import {useLocation } from 'react-router-dom';

import apiPath from "../../../config/apipath";
import apiService from "../../../provider/apiService";
import { Pagination } from "@mui/material";

import config from "../../../config/config";






const PurityTable = () => {

  const [show1, setShow1] = useState(false);
  const [sho, setSho] = useState(false);
  const [show, setShow] = useState(false);
  const handleClose1 = () => setShow1(false);
  const [purity, setPurity] = useState([]);

  const [puritydata, setPuritydata, puritydataRef] = useStateRef('');
  const [purityid, setPurityid, purityidRef] = useStateRef('');
  const [sstatement, setSstatement, sstatementRef] = useStateRef('');

  const [nopage, setnopage, nopageRef] = useStateRef();
  const [totalCount, settotalCount, totalCountRef] = useStateRef();
  const [currentpg, setcurrentpg, currentpgRef] = useStateRef();


  const [resultss, setResultss, resultssRef] = useStateRef();
  const [Search, setSearch, SearchRef] = useStateRef('');

  const [NewElg, setNewElg] = useState(false);
  const [EditElg, setEditElg,EditElgRef] = useStateRef(false);
  const [DeleteElg, setDeleteElg] = useState(false);
  const [ViewElg, setViewElg] = useState(false);
  const [btndisabled, setDisabled] = useState('disabled');
  

  const [errors, setErrors] = useState({});

  const location = useLocation();

  const notify1 = () => toast.success('Successfully Deleted.');
  const notify2 = () => toast.error("Not able to Delete");

  useEffect(() => {
    if (location.state!=undefined || location.state!=null){
    setNewElg(location.state.NewElg);
      setEditElg(location.state.EditElg);
      setDeleteElg(location.state.DeleteElg);
      setViewElg(location.state.ViewElg);

      sessionStorage.setItem("Purity_NewElg", location.state.NewElg);
      sessionStorage.setItem("Purity_EditElg", location.state.EditElg);
      sessionStorage.setItem("Purity_DeleteElg", location.state.DeleteElg);
      sessionStorage.setItem("Purity_ViewElg", location.state.ViewElg);
    }
    else
    {
      setNewElg(sessionStorage.getItem("Purity_NewElg")==='true' ? true: false);
      setEditElg(sessionStorage.getItem("Purity_EditElg")==='true' ? true: false);
      setDeleteElg(sessionStorage.getItem("Purity_DeleteElg")==='true' ? true: false);
      setViewElg(sessionStorage.getItem("Purity_ViewElg")==='true' ? true: false);
    }
      if (EditElgRef.current==true){
        setDisabled('');
      }
      else  
      {
        setDisabled('disabled');
      }

    getPurity(1);
  }, []);

  async function getPurity(page) {
    try {
  
      let postData = {
        PageNumber: String(page),
        RowspPage: config.pageCount,
        Search:SearchRef.current
      }

      

      let results = await apiService.postCall(apiPath.master.get.getPurity,postData);
      if (results != "-1") {
        setPurity(results.data[0]);
        settotalCount(results.totalCount);
        setcurrentpg(postData.PageNumber);
        
      }

    } catch (error) {
      console.log(error);
    }
  }

  async function insertUpdatePurity() {
    try {
      let postData = {
        "value": puritydataRef.current,
        "id": Number(purityidRef.current),
        "StatementType": String(sstatementRef.current)
      }
      let results = await apiService.insertUpdatePurity(apiPath.master.insertUpdate.insertUpdatePurity, postData);

      if (results != "-1") {
        console.log(results, "result insert");
        getPurity(currentpgRef.current);
        setResultss(results)
      }
    } catch (e) {
      console.log(e);
    }

  }

  const SubmitCall = () => {
    try {
      const isFormValid = validateForm();
      if (isFormValid) {
        insertUpdatePurity();
        swal({
          title: "Success",
          text: "Successfully Added",
          icon: "success",
          button: "Ok"
        }).then(function () {
          setShow1(false);
          getPurity(currentpgRef.current)
        });
      }
    } catch (e) {
      console.log(e);

    }
  }
  
  const SubProductPg = (event, value) => {
   getPurity(value);
  };


  const handleShow1 = (type, id, data, statement, show) => {

    setPurityid(id);
    setPuritydata(data);
    setSstatement(statement);

    if (statement == 'Delete') {
      insertUpdatePurity();
      if (resultssRef.current != "-1") {
        notify1();
      }
      else {
        notify2();
      }
    }


    if (type == 1) {
      setSho('Add New');
      setShow('Save');
    } else {
      setSho('Edit');
      setShow('Update');
    }
    setShow1(show);
  }

  const validateForm = () => {
    const newErrors = {};
    if (!puritydata) {
      newErrors.puritydata = 'Account Name is required';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  return (
    <>
      <Row>
        <Col sm="12">

        <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">To Add, Modify Purity details.</h4>
                <Toaster
                  position="bottom-right"
                  reverseOrder={false}
                />
              </div>
              <div>
                <div style={{ display: 'flex', marginLeft: '91px', alignItems: 'center' }}>
                  <div style={{ paddingRight: '10px' }}>
                    <Form.Control type="search" value={Search}  onChange={(e)=>{setSearch(e.target.value)}} className="form-control mr-sm-2" placeholder="Search" aria-label="Search" />
                  </div>
                  <div >
                    <Button className="text-center btn-primary btn-sm btn-icon mt-lg-0 mt-md-0 mt-3 " onClick={(e)=>{
                       setcurrentpg(1)
                       getPurity(currentpgRef.current)}}>
                 <i className="btn-inner">
                        <svg width="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <circle cx="11.7669" cy="11.7666" r="8.98856" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></circle>
                          <path d="M18.0186 18.4851L21.5426 22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                      </i>
                    </Button>
                  </div>
                </div>
              </div>
              <div className="col d-flex justify-content-end">
               {NewElg &&  <Button className="text-center btn-primary btn-icon mt-lg-0 mt-md-0 mt-3 "
                  onClick={() => { handleShow1(1, " ", " ", " ", "Insert", true) }}>
                  <i className="btn-inner">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
                    </svg>
                  </i>
                  <span>Add</span>
                </Button>}
                <Modal show={show1} onHide={handleClose1} >
                  <Modal.Header closeButton>
                    <Modal.Title>{sho} Purity</Modal.Title>
                  </Modal.Header>
                  <Modal.Body >
                    <Form.Group className="mb-3" >

                      <div className='mb-2'>
                        <Form.Label>Value <span className="text-danger">*</span></Form.Label>
                        <Form.Control type="text" id='value' value={puritydata} onChange={(e) => setPuritydata(e.target.value)} isInvalid={!!errors.puritydata} placeholder="Enter Value" />
                      </div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                      <Button variant="primary" disabled={btndisabled} onClick={() => {
                        SubmitCall()
                      }
                      }>{show}
                      </Button>		{' '}
                      <Button variant="danger" onClick={handleClose1}>  Cancel </Button>
                    </div>
                  </Modal.Body>
                </Modal>
              </div>
            </Card.Header>
            <Card.Body>
              <div className="table-responsive border-bottom my-3">
              <Table
                  responsive
                  striped
                  id="datatable"
                  className=""
                  data-toggle="data-table"
                >
                  <thead>
                    <tr>
                      <th>Code</th>
                      <th>Value</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {purity.map((item) => (
                      <tr>
                        <td>{item.id}</td>
                        <td>{item.value}</td>
                        {(EditElg || ViewElg) && 
                        <td>
                          <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit User" to="#"
                            onClick={() => { handleShow1(2, item.id, item.value, "Update", true) }} >
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>
                        </td>
}
{DeleteElg && 
                        <td>
                          <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete User" to="#"
                            onClick={() => { handleShow1(0, item.id, "", "Delete", false) }}>
                            <span className="btn-inner">
                              <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                                <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                                <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              </svg>
                            </span>
                          </Link>

                        </td>}

                      </tr>
                    ))}
                  </tbody>
                </Table>
                <div style={{ display: 'inline-flex', alignItems: 'center', padding: '3px 0 3px 0px', width: '100%', justifyContent: 'space-between' }}>
                  <div>
                    Showing {(currentpgRef.current - 1) * 10 + 1} to {currentpgRef.current * 10} of {totalCountRef.current} entries
                  </div>
                  <div>
                    <Pagination count={Math.ceil(totalCountRef.current / config.pageCount)} page={nopageRef.current} color="primary" onChange={SubProductPg} />
                  </div>
                </div>

              </div>
            </Card.Body>
          </Card>

       
        </Col>
      </Row>
    </>
  );
};

export default PurityTable;
